import { useTranslation } from "react-i18next";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuthStore } from "../stores/authStore";
import { Spinner } from "./ui";

/**
 * Защита маршрутов, требующих входа.
 *
 * Пока сессия восстанавливается по refresh-cookie, редиректить нельзя: иначе
 * при перезагрузке страницы игрока выкидывало бы на логин, хотя он авторизован.
 */
export function RequireAuth() {
  const status = useAuthStore((state) => state.status);
  const location = useLocation();
  const { t } = useTranslation();

  if (status === "loading") {
    return <Spinner label={t("auth.restoring")} />;
  }

  if (status === "anonymous") {
    // Запоминаем, куда игрок шёл, чтобы вернуть его туда после входа.
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <Outlet />;
}
